/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FullOrderViewModel } from './FullOrderViewModel'; 

export function getFullOrderOptions(orderId: string, onSuccess?: (result: FullOrderViewModel) => void) {
	return queryOptions({
		queryKey: ['full-order', orderId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/orders/queries/getfullorder/' + orderId;
			const resp = await axios.get<FullOrderViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(orderId)
	});
}